
import React from "react";
import { Button } from "@/components/ui/button";
import { MessageCircle, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ChatToggleButtonProps {
  isOpen: boolean;
  toggleChat: () => void;
}

const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({
  isOpen,
  toggleChat,
}) => {
  return (
    <Button
      className={cn(
        "fixed bottom-4 right-4 rounded-full w-12 h-12 p-0 shadow-lg transition-all duration-300 z-50",
        isOpen ? "bg-red-500 hover:bg-red-600" : "bg-purple-600 hover:bg-purple-700",
      )}
      onClick={toggleChat}
    >
      {isOpen ? <X size={20} /> : <MessageCircle size={20} />}
    </Button>
  );
};

export default ChatToggleButton;
